import logo from './logo.svg';
import './App.css';
import Menu from './components/menu';
import Home from './pages/home';
import Earn from './pages/earn';
import Tokenomics from './pages/tokenomics';
import Error from './pages/error';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
      errorElement: <Error />,
    },
    {
      path: "earn",
      element: <Earn />,
    },
    {
      path: "tokenomics",
      element: <Tokenomics />,
    },
  ]);
  return (
    <div className="App">
      <Menu />
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
